import  React, { useEffect, useState } from 'react';
import { IonContent, IonPage} from '@ionic/react';
import Axios from 'axios';
import firebase from "firebase/app";
import { useAuth0 } from "@auth0/auth0-react";
import { DiaryForAdmin } from '../components/DiaryForAdmin';
import { Admin} from '../assets/DataStructures'
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import useStyles from '../assets/cssClasses';
import { URLS } from '../assets/URLS';


import { 
  Toolbar, 
  Grid, 
} from '@material-ui/core';   


interface dbProps {
  db: firebase.database.Database | null,
  admin: Admin | null,
  ios: Boolean,
  ids: Array<string>,
}

const DiaryAdminTab: React.FC<dbProps> = (props) => {
  

  const [database, setDB] = useState<firebase.database.Database | null>(null);
  const [surveys, setSurveys] = useState<any>({0: {name: 'fake', path: 'fake'}});

  const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();

  const classes = useStyles();
  
  useEffect(()=>{
    setDB(props.db);
    console.log('setting db')
  }, [props.db]);



  useEffect(()=>{
    
  }, [database]);

  useEffect(() => {
    //alert("setting from admin");
    //alert(JSON.stringify(props.admin))
    //alert(JSON.stringify(props.admin?.active))
    //if(props.ids.length > 0){
      //alert(JSON.stringify(props.ids));
      firebase.auth().signInAnonymously().then(()=>{
        Axios.get(URLS.token, { params: {'duids': props.ids.join('_'), 'uid':  firebase.auth().currentUser?.uid, 'admin': props.admin?.active} }).then(()=>{
          firebase.auth().currentUser?.getIdTokenResult(true).then(res=>{
          console.log(JSON.stringify(res))
          //alert(props.db);
          if(props.db){
            //alert(props.db.ref('/surveys'));
            props.db.ref('/surveys').on('value', function(snapshot) {
              //alert(JSON.stringify(snapshot));
              setSurveys(snapshot.val());
            })
          }
        })})
      })
    //}
    
     
  }, [props.admin, props.ids, props.db]);
 

  const deleteDiary = (keyName:string) => {

    Axios.delete('https://dsm.bright-mr.com/diary/'+keyName).then(function(response){
        console.log(response);
        alert('deleted')
      })
    
  }

  return (
    <IonPage>
      <IonContent>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AppBar className={props.ios?classes.page_title_ios:classes.page_title} position="sticky">
              <Toolbar>
                <Typography className={classes.title} variant="h6"> 
                  <span className={classes.left_align_block}>Bright DSM | Diary Administration
                  {isAuthenticated && 
                    <span> | {user.email}</span>
                  }
                  </span>
                  <span className={classes.right_align_block}>
                  {!isAuthenticated &&
                    <Button onClick={() => loginWithRedirect()} className={classes.actionButton}>Log In as Admin</Button>
                  }
                  {isAuthenticated &&
                    <Button onClick={() => logout({ returnTo: window.location.origin })} className={classes.actionButton}>Log Out</Button>
                  }
                  </span>
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          {(!props.admin || !props.admin?.active) && 
            <Grid item xs={12}>
              Please login first. If you still can't access the desired functionality, please contact rdi@bright-mr.com for help and instructions.
            </Grid>
          }

          {surveys && props.admin?.active &&
            <Grid item xs={12}>
              {Object.keys(surveys).map((keyName, i) => {
                return(
                  <React.Fragment>
                    {surveys[keyName] && 
                      <DiaryForAdmin diary={surveys[keyName]} id={keyName} onDelete={() => deleteDiary(keyName)} admin={props.admin}/>
                    }
                  </React.Fragment>
                )
              })}
            </Grid>
        }
          
        </Grid>
      
      </IonContent>
      </IonPage>

  );
};

export default DiaryAdminTab;
